// extracted by mini-css-extract-plugin
export default {"advertDetailContactItem":"c-m_ft","advertDetailContactItem__link":"c-m_fu"};